module.exports = __webpack_public_path__ + "media/images/Group 3-3385ba960c2cf865f4514f7f095fe3c0.svg";